const commands = {
  SET_COOKIE: 'set-cookie',
};

const endpoint = '__events_domain__/v2/client-cookies';

module.exports = {
  commands,
  endpoint,
};
